// extracted by mini-css-extract-plugin
module.exports = {"banner":"n_bw","icon":"n_br","title":"n_bx","text":"n_by","button":"n_bz"};